/*
 *   File : aprrove-kyc.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for approving kyc.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

/* import components */
import { GradientButton } from "../Cta";
import { Icon } from "../Icon";

/* import styles */
import style from "../../Styles/Components/delete.module.scss";

/* import helper */

const SingleSipModal = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
        var my_modal = document.getElementById("single-sip-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);


    return (
        <div className={`modal fade ${style.e_approve_kyc}`}
            id="single-sip-modal"
            tabIndex="-1"
            aria-labelledby="single-sip-modal"
            aria-hidden="true"
            data-bs-backdrop="true">

            <div className={`modal-dialog modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white padding-32px-all ${style.e_content}`}>

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="e-poppins-semi-bold e-font-16 color-dark-black mb-0">
                            SIP Detail
                        </h6>
                        <Icon
                            icon="close"
                            size={24}
                            className="cursor-pointer e-modal-close-btn"
                            data-bs-dismiss="modal"
                        />
                    </div>

                    {/* Date */}
                    <div className="pt-4">
                        <p className="e-poppins-medium e-font-16 color-dark-black mb-0">
                            {props.date}
                        </p>
                    </div>

                    {/* List Area */}
                    <div className="pt-3" style={{ maxHeight: "380px", overflowY: "auto" }}>

                        {props.events.length > 0 ? (
                            props.events.map((item, index) => (
                                <div
                                    key={index}
                                    className="border-1 border-bright-gray rounded-3 p-3 mb-3"
                                    style={{ background: "#F8FAFF" }}
                                >
                                    {/* Title */}
                                    {/* <div className="mb-2">
                                        <p className="e-poppins-medium e-font-15 color-primary-color mb-1">
                                            {item.title || "-"}
                                        </p>
                                    </div> */}

                                    <div className="d-flex justify-content-start gap-2 mb-1">
                                        <span className="color-black e-poppins-regular e-font-14">Title: </span>
                                        <span className="color-outer-space e-poppins-medium e-font-14">
                                            {item.title}
                                        </span>
                                    </div>

                                    {/* Name */}
                                    <div className="d-flex justify-content-start gap-2 mb-1">
                                        <span className="color-black e-poppins-regular e-font-14">Name: </span>
                                        <span className="color-outer-space e-poppins-medium e-font-14">
                                            {item.name}
                                        </span>
                                    </div>

                                    {/* Client code */}
                                    <div className="d-flex justify-content-start gap-2 mb-1">
                                        <span className="color-black e-poppins-regular e-font-14">Client code: </span>
                                        <span className="color-dark-black e-poppins-medium e-font-14">
                                            {item.client_code}
                                        </span>
                                    </div>

                                    {/* SIP Date */}
                                    <div className="d-flex justify-content-start gap-2 mb-1">
                                        <span className="color-black e-poppins-regular e-font-14">SIP Date: </span>
                                        <span className="color-dark-black e-poppins-medium e-font-14">
                                            {item.date}
                                        </span>
                                    </div>

                                    {/* Fund Name */}
                                    <div className="d-flex justify-content-start gap-2 mb-1">
                                        <span className="color-black e-poppins-regular e-font-14">Fund: </span>
                                        <span className="color-outer-space e-poppins-medium e-font-14">
                                            {item.fund}
                                        </span>
                                    </div>

                                    {/* Amount */}
                                    <div className="d-flex justify-content-start gap-2 mb-1">
                                        <span className="color-black e-poppins-regular e-font-14">Amount: </span>
                                        <span className="color-dark-black e-poppins-medium e-font-14">
                                            ₹{item.amount}
                                        </span>
                                    </div>



                                </div>
                            ))
                        ) : (
                            <p className="e-poppins-regular e-font-14 color-dark-black mb-0">
                                No SIP's available
                            </p>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );

}


SingleSipModal.defaultProps = {
    close: () => { }
}

export default SingleSipModal